module.exports = __webpack_public_path__ + "img/JOAO PAULO.cd740420.jpeg";